import { Paragraph } from 'docx';
import { EsrsReportCategory, EsrsReportData, SideMenuStructure } from '../../Report.types';
import { TextStyle } from '../reportThemes';
import { createCategories } from './categories';
import { addEmptySpace } from '../report-helper-functions';
import { createOtherEULegislationsTable } from '../CustomTables/other-eu-legislations';

export const createSections = (
  {
    companyName,
    reportingYear,
    categories,
    materialStandards,
    structure,
  }: {
    companyName: string;
    reportingYear: number;
    categories: EsrsReportCategory[];
    materialStandards: EsrsReportData['materialStandards'];
    structure: SideMenuStructure;
  },
  companyCurrency: string
) => {
  const reportStandards = categories.flatMap((category) => category.standards);

  const showAppendix = reportStandards?.some((standard) =>
    standard.disclosureRequirements.some((dr) =>
      dr.metrics.some(
        (metric) =>
          metric.metric.metricRef ===
            'disclosureoflistofdatapointsthatderivefromothereulegislationandinformationontheirlocationinsustainabilitystatement' &&
          metric.metric.isMaterial
      )
    )
  );

  return [
    new Paragraph({
      text: `ESRS sustainability statement for ${companyName} ${reportingYear}`,
      style: TextStyle.title,
      spacing: {
        after: 400,
      },
    }),
    createCategories(categories ?? [], companyCurrency, reportingYear, structure),
    addEmptySpace(300),

    ...(showAppendix
      ? [
          new Paragraph({
            text: 'Appendix',
            style: TextStyle.h2,
            spacing: {
              after: 200,
            },
          }),
          ...createOtherEULegislationsTable(materialStandards, reportStandards),
        ]
      : []),
  ].flat();
};
